<template>
  <div class="row">
    <div class="col-12 text-h6 text-center">物料變更紀錄</div>
    <div class="col-12">
      <div>
        <q-tabs
          v-model="tab"
          align="justify"
          narrow-indicator
          class="q-mb-lg bg-grey-3"
        >
          <q-tab label="本地採購" class="text-blue" name="purchaseLocal"></q-tab>
          <q-tab label="領出" class="text-blue" name="collar"></q-tab>
          <q-tab label="銷售" class="text-blue" name="sale"></q-tab>
          <q-tab label="退貨" class="text-blue" name="return"></q-tab>
          <q-tab label="調整庫存" class="text-blue" name="product" ></q-tab>
          <q-tab label="進貨批號" class="text-blue" name="batch" ></q-tab>
        </q-tabs>
      </div>
      <div>
        <q-tab-panels
          v-model="tab"
          animated
          transition-prev="fade"
          transition-next="fade"
          class="bg-grey-2"
          style="height: 650px;"
        >
          <q-tab-panel name="product">
            <q-table
              :data="productLog.ProductLog"
              :columns="productColumns"
              row-key="name"
              class="full-width full-height"
              :pagination.sync="tabelSet"
            >
              <template v-slot:body="props">
                <q-tr :props="props">
                  <q-td key="title" :props="props">
                    {{ props.row.action }}
                  </q-td>
                  <q-td key="time" :props="props">
                    {{ props.row.created_at.replace("T", " ").replace("+08:00", "") }}
                  </q-td>
                </q-tr>
              </template>
            </q-table>
          </q-tab-panel>
          <q-tab-panel name="collar">
            <q-table
              :data="productLog.CollarLog"
              :columns="collarColumns"
              row-key="name"
              class="full-width full-height"
              :pagination.sync="tabelSet"
            >
              <template v-slot:body="props">
                <q-tr :props="props">
                  <q-td key="collar" :props="props">
                    <router-link v-if="handleCollarShow(props.row)" :to="'/collar/return-edit/'+props.row.Collar.id" target="_blank">
                      <q-btn label="明細" color="blue" />
                    </router-link>
                  </q-td>
                  <q-td key="stock" :props="props">
                    {{ props.row.quantity }}
                  </q-td>
                  <q-td key="return" :props="props">
                    {{ props.row.Record.Return }}
                  </q-td>
                  <q-td key="note" :props="props">
                    {{ props.row.Collar.note }}
                  </q-td>
                  <q-td key="time" :props="props">
                    {{ props.row.created_at.replace("T", " ").replace("+08:00", "") }}
                  </q-td>
                  <q-td key="returnTime" :props="props">
                    {{ (ParseDate(props.row.Record.created_at))? props.row.Record.created_at.replace("T", " ").replace("+08:00", "") : "" }}
                  </q-td>
                  <q-td key="Oe" :props="props">
                    {{ props.row.OeContent.oeno }} {{ (props.row.OeContent.Patient.cussn)? `(${props.row.OeContent.Patient.cusname})`: `` }}
                  </q-td>
                  <q-td key="Oc" :props="props">
                    {{ (props.row.OeCourse && props.row.OeCourse.Header && props.row.OeCourse.Header.id)?props.row.OeCourse.Header.id : '' }} 
                    {{ (props.row.OeCourse && props.row.OeCourse.Header && props.row.OeCourse.Header.id)?`(${props.row.OeCourse.Header.Patient.cusname})` : '' }}
                  </q-td>
                </q-tr>
              </template>
            </q-table>
          </q-tab-panel>
          <q-tab-panel name="sale">
            <q-table
              :data="productLog.SaleLog"
              :columns="saleColumns"
              row-key="name"
              class="full-width full-height"
              :pagination.sync="tabelSet"
            >
              <template v-slot:body="props">
                <q-tr :props="props">
                  <q-td key="user" :props="props">
                    {{ props.row.Sale.User.nick_name }}
                  </q-td>
                  <q-td key="stock" :props="props">
                    {{ props.row.quantity }}
                  </q-td>
                  <q-td key="single" :props="props">
                    {{ props.row.price }}
                  </q-td>
                  <q-td key="price" :props="props">
                    {{ props.row.total }}
                  </q-td>
                  <q-td key="time" :props="props">
                    {{ props.row.created_at.replace("T", " ").replace("+08:00", "") }}
                  </q-td>
                  <q-td key="Oe" :props="props">
                    {{ props.row.OeContent.oeno }} {{ (props.row.OeContent.Patient.cussn)? `(${props.row.OeContent.Patient.cusname})`: `` }}
                  </q-td>
                </q-tr>
              </template>
            </q-table>
          </q-tab-panel>
          <q-tab-panel name="return">
            <q-table
              :data="productLog.ReturnLog"
              :columns="purchaseColumns"
              row-key="name"
              class="full-width full-height"
              :pagination.sync="tabelSet"
            >
              <template v-slot:body="props">
                <q-tr :props="props">
                  <q-td key="stock" :props="props">
                    {{ props.row.quantity }}
                  </q-td>
                  <q-td key="note" :props="props">
                    {{ props.row.Return.note }}
                  </q-td>
                  <q-td key="time" :props="props">
                    {{ props.row.created_at.replace("T", " ").replace("+08:00", "") }}
                  </q-td>
                </q-tr>
              </template>
            </q-table>
          </q-tab-panel>
          <q-tab-panel name="purchaseLocal">
            <q-table
              :data="productLog.PurchaseLocalLog"
              :columns="purchaseLocalColumns"
              row-key="name"
              class="full-width full-height"
              :pagination.sync="tabelSet"
            >
              <template v-slot:body="props">
                <q-tr :props="props">
                  <q-td key="purchase" :props="props">
                    <router-link :to="'/purchase/offline-edit/'+props.row.Purchase.id" target="_blank">
                      {{ props.row.Purchase.purchase_no }}
                    </router-link>
                  </q-td>
                  <q-td key="supplier" :props="props">
                    {{ props.row.Purchase.supplierDetail.title }}
                  </q-td>
                  <q-td key="stock" :props="props">
                    {{ props.row.arrival_stock }}
                  </q-td>
                  <q-td key="give" :props="props">
                    {{ props.row.give_stock }}
                  </q-td>
                  <q-td key="time" :props="props">
                    {{ props.row.created_at.replace("T", " ").replace("+08:00", "") }}
                  </q-td>
                </q-tr>
              </template>
            </q-table>
          </q-tab-panel>
          <q-tab-panel name="batch">
            <q-table
              :data="productLog.PurchaseBatchLog"
              :columns="purchaseBatchColumns"
              row-key="name"
              class="full-width full-height"
              :pagination.sync="tabelSet"
            >
              <template v-slot:body="props">
                <q-tr :props="props">
                  <q-td key="purchase" :props="props">
                    <router-link :to="'/purchase/offline-edit/'+props.row.purchase_id" target="_blank">
                      採購單
                    </router-link>
                  </q-td>
                  <q-td key="product" :props="props">
                    <img :src="props.row.PurchaseBatch.product_image" style="width:120px;"/>
                  </q-td>
                  <q-td key="batch" :props="props">
                    <img :src="props.row.PurchaseBatch.batch_image" style="width:120px;"/>
                  </q-td>
                  <q-td key="stock" :props="props">
                    {{ props.row.buy }}
                  </q-td>
                  <q-td key="time" :props="props">
                    {{ props.row.PurchaseBatch.created_at.replace("T", " ").replace("+08:00", "") }}
                  </q-td>
                </q-tr>
              </template>
            </q-table>
          </q-tab-panel>
        </q-tab-panels>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { ParseDate } from "@/utils"
  export default {
    name: "ProductLog",
    props: {},
    data() {
      return {
        tab: '',
        tabelSet: {
          sortBy: 'desc',
          descending: false,
          page: 1,
          rowsPerPage: 10
        },
        productColumns: [
          { name: 'title', align: 'center', label: '操作', field: 'action'},
          { name: 'time', align: 'center', label: '時間', field: 'rate'},
        ],
        collarColumns: [
          { name: 'collar', align: 'center', label: '領用單', field: 'collar' },
          { name: 'stock', align: 'center', label: '領用數', field: 'quantity' },
          { name: 'return', align: 'center', label: '歸還數', field: 'quantity' },
          { name: 'note', align: 'center', label: '領用備註', field: 'note' },
          { name: 'time', align: 'center', label: '領用時間', field: 'created_at' },
          { name: 'returnTime', align: 'center', label: '歸還時間', field: 'created_at' },
          { name: 'Oe', align: 'center', label: '治療單號' },
          { name: 'Oc', align: 'center', label: '課程單號' },
        ],
        saleColumns: [
          { name: 'user', align: 'center', label: '銷售人員', field: 'quantity' },
          { name: 'stock', align: 'center', label: '銷售數量', field: 'quantity' },
          { name: 'single', align: 'center', label: '價格', field: 'quantity' },
          { name: 'price', align: 'center', label: '銷售金額', field: 'price' },
          { name: 'time', align: 'center', label: '時間', field: 'created_at' },
          { name: 'Oe', align: 'center', label: '治療單號' },
        ],
        purchaseColumns: [
          { name: 'stock', align: 'center', label: '退貨數量', field: 'arrival_stock' },
          { name: 'note', align: 'center', label: '退貨備註', field: 'arrival_stock' },
          { name: 'time', align: 'center', label: '時間', field: 'created_at' },
        ],
        purchaseLocalColumns: [
          { name: 'purchase', align: 'center', label: '採購單號', field: 'arrival_stock' },
          { name: 'supplier', align: 'center', label: '供應商', field: 'arrival_stock' },
          { name: 'stock', align: 'center', label: '到貨數量', field: 'arrival_stock' },
          { name: 'give', align: 'center', label: '贈送數量', field: 'give_stock' },
          { name: 'time', align: 'center', label: '到貨時間', field: 'created_at' },
        ],
        purchaseBatchColumns: [
          { name: 'purchase', align: 'center', label: ''},
          { name: 'product', align: 'center', label: '驗收照片'},
          { name: 'batch', align: 'center', label: '批號照片'},
          { name: 'stock', align: 'center', label: '購買數量', field: 'arrival_stock' },
          { name: 'time', align: 'center', label: '拍照時間', field: 'created_at' },
        ],
      }
    },
    computed: {
      ...mapGetters(['productDetail', 'productLog'])
    },
    created(){
      this.$store.dispatch('productGetChangeLog', this.$route.params.id)
    },
    methods: {
      handleCollarShow(row) {
        let check = true
        if (row.OeContent && row.OeContent.id) {
          check = false
        }

        if (row.OeCourse && row.OeCourse.Header && row.OeCourse.Header.id) {
          check = false
        }

        return check 
      },
      ParseDate,
    }
  }
</script>

<style scoped>

</style>
